import React, { useState, useEffect } from "react";

import Sidebar from "../../components/Sidebar";
import CoverForm from "./Cover/Form";

import { getAlert } from "../../../utils/SamuiUtils";

const Cover = () => {
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRefresh = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <div className="Cover">
            <div className="wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="container">
                        <div className="page-inner">
                            <CoverForm key={refreshKey} callRefresh={handleRefresh} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cover;
